import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import toastr from '../toastr'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import DatePicker from '../../component/dccore-form/datePicker.vue'
import MoneyBoxHistory from '../../component/view/MoneyBoxHistory.vue'
import BootstrapVue from 'bootstrap-vue'
import SurchargePayment from './surchargePayment.vue'
import History from './history.vue'

if ($('#order_form').length) {
  Vue.use(VueResource)
  Vue.use(BootstrapVue)
  new Vue({
    el: '#order_form',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      DatePicker,
      MoneyBoxHistory,
      SurchargePayment,
      History
    },
    mixins: [mixins],
    data: {
      loading: 1,
      entityId: null,
      buttonDisabled: false,
      form: {
        entity: {
          user: {},
          paymentStatus: {},
          priceBeforeDiscount: 0,
          waitingForBankWirePayment: 0,
          needFv: 0,
          active: 0,
          contactWithUs: 0,
          priceDiscount: 0,
          invoice: null,
          updatedAt: null,
          flow: {},
          platform: {},
        },
        selected: {},
        errors: {}
      },
      priceDiscountDisplay: '',
      clientTypes: [],
    },
    computed: {
      invoice() {
        return Translator.trans(this.form.entity.invoice)
      },
    },
    watch: {
      'form.entity.priceBeforeDiscount': function () {
        this.calcDiscount()
      },
      'form.entity.priceDiscount': function () {
        this.calcDiscount()
      }
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getOrder()
        this.getClientTypes()
      }

      this.loading--

    },
    methods: {
      disabledButton(value) {
        this.buttonDisabled = value
      },
      updateOrder (redirect) {
        this.form.errors = {}
        this.loading++
        let url = Routing.generate('api_patch_order', {
          id: this.entityId
        })
        let data = {
          data: {
            pricePayedByTransfer: this.form.entity.pricePayedByTransfer,
            waitingForBankWirePayment: this.form.entity.waitingForBankWirePayment,
            active: this.form.entity.active,
            contactWithUs: this.form.entity.contactWithUs,
            nip: this.form.entity.nip,
            needFv: this.form.entity.needFv,
            updatedAt: this.form.entity.updatedAt,
            clientType: this.form.entity.clientType,
          }
        }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('order_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.errors = {}
            this.getOrder()
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form)
        })
      },
      getOrder () {
        this.loading++
        let url = Routing.generate('api_get_order', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      calcDiscount () {
        let discount = this.form.entity.priceBeforeDiscount - this.form.entity.priceAfterDiscount
        let value = this.dcNumberFormat(this.form.entity.priceBeforeDiscount - this.form.entity.priceAfterDiscount)
        let percent = Math.round((discount / this.form.entity.priceBeforeDiscount) * 100 * 100) / 100
        if (!isNaN(percent)) {
          this.priceDiscountDisplay = `${value} (${this.dcNumberFormat(percent)}%)`
        } else {
          this.priceDiscountDisplay = 0
        }
      },
      goOrder (id) {
        window.location.href = Routing.generate('order_update', { id: id })
      },
      editPriceFromMoneyboxCallBack (newValue) {
        return new Promise((resolve, reject) => {
          this.$http.patch(Routing.generate(
            'api_patch_order_price_from_money_box',
            {id: this.entityId}),
            {data: {priceFromMoneybox: newValue}})
            .then(response => {
              resolve(response)
            }, response => {
              reject({
                message: response.body.errors.priceFromMoneybox ?
                    response.body.errors.priceFromMoneybox[1] :
                    response.body.errors[1]
              })
            })
        })
      },
      savedPriceFromMoneybox() {
        this.getOrder()
      },
      askForSurchargeUri() {
        this.$refs.surcharge.generateSurchargeUri(this.entityId)
      },
      surchargeModalShow() {
        this.$bvModal.show('surchargeModal')
      },
      surchargeModalHide() {
        this.$bvModal.hide('surchargeModal')
      },
      getClientTypes() {
        this.loading++
        const url = Routing.generate('api_get_tags', { 'type': 'client_type',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.clientTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
    }
  })
}
